export default "__VITE_ASSET__BhJRMkTw__"